import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Tooltip } from 'primeng/tooltip';
import { BaseAddPaymentPageLinkComponent } from '../../base/base-add-payment-page-link.component';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'add-form-payment-page-link-integration',
  imports: [
    InputText,
    ReactiveFormsModule,
    FormsModule,
    Button,
    Tooltip,
  ],
  templateUrl: './add-form-payment-page-link-integration.component.html'
})
export class AddFormPaymentPageLinkIntegrationComponent extends BaseAddPaymentPageLinkComponent {

  constructor(private clipboard: Clipboard) {
    super();
  }

  /**
   * copy link or button-html to clipboard
   * @param clipboardData
   */
  copyToClipboard(clipboardData: string) {
    this.clipboard.copy(clipboardData);
  }

}
